/**
 * CfssTrainingPage — Worker Training Compliance
 *
 * MN 256B.0659 Subd 11-12: CFSS worker training requirements
 * Thin wrapper around shared TrainingCompliancePage with CFSS config.
 *
 * Route: /cfss/training
 */

import { TrainingCompliancePage } from '@/pages/shared-services';

export function CfssTrainingPage() {
  return (
    <TrainingCompliancePage
      title="Training Compliance"
      subtitle="Required trainings per MN 256B.0659 Subd 11-12"
      taskGroupRef="4-30-20"
      scope="cfss:training:view"
    />
  );
}

export default CfssTrainingPage;
